import { render, staticRenderFns } from "./RPreview.vue?vue&type=template&id=bf584d20&"
import script from "./RPreview.vue?vue&type=script&lang=js&"
export * from "./RPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports